export const CREDIT_CHECK_STATUS = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  DOC_REQUIRED: 'DOC_REQUIRED',
  ERROR: 'ERROR',
}

export const getCreditCheckTextId = status => {
  switch (status) {
    case CREDIT_CHECK_STATUS.DOC_REQUIRED:
      return 'CREDIT_CHECK_STATUS/Additional documentation required'
    case CREDIT_CHECK_STATUS.APPROVED:
      return 'CREDIT_CHECK_STATUS/Credit approved'
    case CREDIT_CHECK_STATUS.REJECTED:
      return 'CREDIT_CHECK_STATUS/Credit rejected'
    case CREDIT_CHECK_STATUS.PENDING:
    default:
      return 'CREDIT_CHECK_STATUS/Credit check pending'
  }
}
